<ion-item [class]="containerClass" lines="none">
  <ion-checkbox
    slot="start"
    [class]="checkboxClass"
    [disabled]="disabled"
    [name]="name"
    [checked]="internalValue"
    (ionChange)="onIonChange($event)"
    mode="ios"
  ></ion-checkbox>
  <ion-label class="checkbox-getm-text" *ngIf="label">
    {{ label }}
  </ion-label>
</ion-item>
